export enum SearchByLocationOptions {
  CurrentLocation,
  RegisteredAddress,
}
